export default "__VITE_ASSET__BnqhhUUu__"